import React from 'react';
import './StatCard.css'

const StatCard = (props) => {
    return ( 
        <div className='StatCard'>
            <p className='SCardText'>
                <p className='SCardName'>{props.SCardName}</p>
                <p className='SCardNum'>{props.SCardNum}</p>
            </p>

            <img src={props.SCardIcon} alt="" />
        </div>
     );
}
 
export default StatCard;
